module.exports = __webpack_public_path__ + "img/blocMD.a5405a76.png";